import React, { useEffect, useState } from "react";
import VerifyNumberAbha from "./verify-number-abha";
import { AlreadyAbhaVerifyNumber, EncryptDataABDM } from "../../services";
import { toast } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import { setResentCount } from "../../redux/slices/abhaSlice";

import formBgImg from "../../assets/image/Group 2147206200.png";
import about from "../../assets/image/about_nha_pg_logo.png";

const AbhaNumberDetails = ({ setResMessage, resMessage, handleBack }) => {
  const [verifyNumberAbha, setVerifyNumberAbha] = useState(false);
  const [consent, setConsent] = useState(false);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [abhaDetails, setAbhaDetails] = useState(null);
  const [selectedAbha, setSelectedAbha] = useState(null);

  const resendCount = useSelector((state) => state.user.resentCount);
  const dispatch = useDispatch();

  useEffect(() => {
    const storedAbhaDetails = localStorage.getItem("abhaDetails");
    if (storedAbhaDetails) {
      try {
        const parsed = JSON.parse(storedAbhaDetails);
        setAbhaDetails(parsed || parsed.abha);
      } catch (err) {
        console.error("Invalid ABHA details in localStorage", err);
      }
    }
  }, []);

  const getAbhaList = () => {
    if (!abhaDetails) return [];
    if (Array.isArray(abhaDetails.abha)) return abhaDetails.abha;
    if (typeof abhaDetails.abha === "object") return [abhaDetails.abha];
    return [];
  };

  const handleCardSelect = (item) => setSelectedAbha(item);

  const handleVerifyNumberAbha = async (e) => {
    e.preventDefault();
    if (!consent) { setError("Please accept the consent checkbox."); return; }
    if (!abhaDetails || !abhaDetails.inputValue) { setError("No ABHA details found."); return; }
    if (!selectedAbha) { toast.error("Please select an ABHA card."); return; }
    setError("");
    setLoading(true);
    try {
      const encryptedInput = await EncryptDataABDM({ body: abhaDetails?.inputValue });
      const requestData = {
        scope: ["abha-login", "mobile-verify"],
        loginHint: "mobile",
        loginId: encryptedInput.data,
        otpSystem: "abdm",
        resent_count: resendCount,
      };
      const response = await AlreadyAbhaVerifyNumber({ headers: {}, data: requestData });
      if (response?.resent_count !== undefined) dispatch(setResentCount(response.resent_count));
      if (response.success === false) { toast.error(response.message || "Failed to send OTP"); return; }
      if (response.success === true) {
        const txnId = response?.data?.txnId;
        if (txnId) localStorage.setItem("txnId", txnId);
        setResMessage(response.message);
        setVerifyNumberAbha(true);
      }
    } catch (err) {
      console.error(err);
      setError(err?.message || "Something went wrong. Please try again later.");
    } finally {
      setLoading(false);
    }
  };

  const abhaList = getAbhaList();

  if (verifyNumberAbha) {
    return (
      <VerifyNumberAbha
        handleBack={() => setVerifyNumberAbha(false)}
        inputType="mobile"
        inputValue={abhaDetails?.inputValue || ""}
        otpType="abdm"
        initialResentCount={resendCount}
        setResMessage={setResMessage}
        autoComplete="off"
        resMessage={resMessage}
        selectedAbhaCard={selectedAbha}
      />
    );
  }

  return (
    <div className="col-12 col-md-6">
      <div
        className="lmop-card-wrap"
        style={{
          backgroundImage: `url(${formBgImg})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      >
        <div className="lmop-card-inner">
          <h3 className="lmop-card-title" style={{ fontSize: "1.2rem" }}>
            ABHA Number / ABHA Address
          </h3>
          <p className="lmop-card-subtitle">Select your ABHA to continue</p>

          {/* ABHA cards list */}
          <div style={{ maxHeight: "220px", overflowY: "auto", marginBottom: "16px" }}>
            {abhaList.length > 0 ? (
              abhaList.map((item, idx) => (
                <div
                  key={idx}
                  onClick={() => handleCardSelect(item)}
                  style={{
                    padding: "14px 16px",
                    borderRadius: "10px",
                    border: `1.5px solid ${selectedAbha?.ABHANumber === item.ABHANumber ? "#1a7fff" : "#e2e5ec"}`,
                    background: selectedAbha?.ABHANumber === item.ABHANumber ? "rgba(26,127,255,0.06)" : "#f5f6f8",
                    marginBottom: "10px",
                    cursor: "pointer",
                    transition: "all 0.2s",
                  }}
                >
                  <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start" }}>
                    <div>
                      <p style={{ margin: "0 0 4px", fontSize: "0.9rem", fontWeight: "700", color: "#111" }}>
                        {item.name}
                      </p>
                      <p style={{ margin: "0 0 2px", fontSize: "0.78rem", color: "#666" }}>
                        <strong>ABHA:</strong> {item.ABHANumber}
                      </p>
                      <p style={{ margin: "0 0 2px", fontSize: "0.78rem", color: "#666" }}>
                        <strong>Gender:</strong> {item.gender}
                      </p>
                      <p style={{ margin: "0", fontSize: "0.78rem", color: "#666" }}>
                        <strong>KYC:</strong>{" "}
                        <span style={{ color: item.kycVerified ? "#00c48c" : "#cf1f1f", fontWeight: "600" }}>
                          {item.kycVerified ? "Verified" : "Not Verified"}
                        </span>
                      </p>
                    </div>
                    {/* Selection indicator */}
                    <div style={{
                      width: "20px",
                      height: "20px",
                      borderRadius: "50%",
                      border: `2px solid ${selectedAbha?.ABHANumber === item.ABHANumber ? "#1a7fff" : "#ccc"}`,
                      background: selectedAbha?.ABHANumber === item.ABHANumber ? "#1a7fff" : "transparent",
                      flexShrink: 0,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}>
                      {selectedAbha?.ABHANumber === item.ABHANumber && (
                        <span style={{ color: "#fff", fontSize: "11px", fontWeight: "700" }}>✓</span>
                      )}
                    </div>
                  </div>
                </div>
              ))
            ) : (
              <p style={{ color: "#888", fontSize: "0.85rem" }}>No ABHA records found.</p>
            )}
          </div>

          {/* Consent checkbox */}
          <div className="d-flex mb-3">
            <input
              type="checkbox"
              className="form-check-input checkbox-color"
              id="consentCheck"
              autoComplete="off"
              checked={consent}
              onChange={() => setConsent((v) => !v)}
            />
            <label
              className="form-check-label ps-2"
              htmlFor="consentCheck"
              style={{ fontSize: "0.8rem", color: "#555", lineHeight: "1.5" }}
            >
              I agree to give my consent to AbyM to link and update
              my details as per ABHA Address
            </label>
          </div>

          {error && <p className="lmop-msg-err">{error}</p>}

          {/* Back + Link Now buttons */}
          <div className="d-flex gap-3">
            <button
              type="button"
              onClick={handleBack}
              style={{
                flex: 1,
                padding: "14px",
                borderRadius: "999px",
                border: "1.5px solid #d0d5e0",
                background: "transparent",
                color: "#555",
                fontFamily: "Manrope, sans-serif",
                fontWeight: "700",
                fontSize: "0.92rem",
                cursor: "pointer",
              }}
            >
              Back
            </button>
            <button
              type="button"
              className={`lmop-continue-btn ${!consent || loading ? "bg-disable" : ""}`}
              onClick={handleVerifyNumberAbha}
              disabled={!consent || loading}
              style={{ flex: 1, marginTop: 0 }}
            >
              {loading ? "Linking..." : "Link Now"}
            </button>
          </div>

          <div className="lmop-nha-row">
            <span className="lmop-nha-label">Approved by NHA</span>
            <img src={about} alt="NHA Logo" className="lmop-nha-logo" />
          </div>

        </div>
      </div>
    </div>
  );
};

export default AbhaNumberDetails;